// One physical content box for all thermal documents. Values are millimetres.
export function receiptGeometry(settings = {}) {
  const custom = Number(settings.custom_paper_width ?? 80);
  const paper = settings.paper === 'custom' && Number.isFinite(custom) && custom >= 40 && custom <= 210
    ? custom : String(settings.paper) === '58' ? 58 : 80;
  const printable = Math.round((paper - (paper <= 58 ? 10 : 8)) * 100) / 100;
  const margin = (value, fallback) => value != null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= 15 ? Number(value) : fallback;
  let left = margin(settings.receipt_margin_left_mm, 4), right = margin(settings.receipt_margin_right_mm, 2);
  if (left + right > printable - 10) { left = 4; right = 2; }
  return { paper, printable, left, right, content: Math.round((printable - left - right) * 100) / 100 };
}
export function receiptContentInsets(settings = {}) {
  const g = receiptGeometry(settings);
  // The V2 paper test kept all first characters but still looked a little
  // right-heavy on the physical 80mm roll. Move only the inner content 1mm
  // toward the left while retaining the driver's 4mm outer inset.
  const shift = Math.min(1, g.left);
  return { left: Math.round((g.left - shift) * 100) / 100, right: Math.round((g.right + shift) * 100) / 100 };
}
export function receiptBoxCss(settings = {}) {
  const g = receiptGeometry(settings), inset = receiptContentInsets(settings);
  // Retain a symmetric 4mm safety inset even when the Windows driver exposes
  // a page narrower than the configured paper. max-width:100% consumed this
  // protection on narrow pages; the physical 1mm test clipped initial letters.
  // User margins are additional padding; never shrink text or use a negative offset.
  return `width: ${g.printable}mm; max-width: calc(100% - 8mm); margin: 0 auto; padding: 2mm ${inset.right}mm 2mm ${inset.left}mm; box-sizing: border-box;`;
}
export function escposGeometry(settings = {}) {
  const g = receiptGeometry(settings), left = Math.round(g.left * 8), dots = Math.round(g.content * 8);
  return { columns: Math.max(8, Math.floor(dots / 12)), commands: [29,76,left & 255,left >> 8,29,87,dots & 255,dots >> 8] };
}
